module.exports = __webpack_public_path__ + "static/img/login_bg02@2x.13a79dc4.png";